import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class DataService {
  private readonly LS_SMS_PREPAID_ENTERPRISE_PRESENT = 'sms_prepaid_enterprise_present';
  private _accountStatus = new BehaviorSubject(null);
  accountStatus$ = this._accountStatus.asObservable();

  private _planType = new BehaviorSubject(null);
  planType$ = this._planType.asObservable();

  private _isPepiClient = new BehaviorSubject(null);
  isPepiClient$ = this._isPepiClient.asObservable();

  private _isUnlimitedCodeApplied = new BehaviorSubject(null);
  isUnlimitedCodeApplied$ = this._isUnlimitedCodeApplied.asObservable();

  private _warmupSlabDetails = new BehaviorSubject(null);
  warmupSlabDetails$ = this._warmupSlabDetails.asObservable();

  private _profileInfo = new BehaviorSubject(null);
  profileInfo$ = this._profileInfo.asObservable();

  private _fetchClientId = new BehaviorSubject(null);
  fetchClientId$ = this._fetchClientId.asObservable();

  private _fetchDomainList = new BehaviorSubject(null);
  fetchDomainList$ = this._fetchDomainList.asObservable();

  private _fetchCredits = new BehaviorSubject(null);
  fetchCredits$ = this._fetchCredits.asObservable();

  private _fetchActivePreferredPlan = new BehaviorSubject(null);
  fetchActivePreferredPlan$ = this._fetchActivePreferredPlan.asObservable();

  private _fetchNewSlabCredits = new BehaviorSubject(null);
  fetchNewSlabCredits$ = this._fetchNewSlabCredits.asObservable();

  private _availableEmailCredits = new BehaviorSubject(null);
  availableEmailCredits$ = this._availableEmailCredits.asObservable();

  private _suppresionCount = new BehaviorSubject(null);
  suppresionCount$ = this._suppresionCount.asObservable();

  private _checkSubuser = new BehaviorSubject(null);
  checkSubuser$ = this._checkSubuser.asObservable();

  private _newUI = new BehaviorSubject<boolean>(false);
  newUI$ = this._newUI.asObservable();

  private _newUIClass = new BehaviorSubject<string>(null);
  newUIClass$ = this._newUIClass.asObservable();

  private _activePath = new BehaviorSubject<string>(null);
  activePath$ = this._activePath.asObservable();

  private _pageLevelAccess_Map = new BehaviorSubject([]); //table - trans_configure_insights page / content level access
  pageLevelAccess_Map = this._pageLevelAccess_Map.asObservable();

  private _insightsClickFilters = new BehaviorSubject([]);
  insightsClickFilters$ = this._insightsClickFilters.asObservable();

  private _isFirstTimeExperience = new BehaviorSubject(null);
  isFirstTimeExperience$ = this._isFirstTimeExperience.asObservable();

  private _isWaTokenGenerated = new BehaviorSubject<boolean>(
    sessionStorage.getItem('whatsappToken') === 'true'
  );
  isWaTokenGenerated$ = this._isWaTokenGenerated.asObservable();

  private _isHashEnabled = new BehaviorSubject(null);
  isHashEnabled$ = this._isHashEnabled.asObservable();

  private _isWaMobileNumberData = new BehaviorSubject([]);
	waMobileNumberData$ = this._isWaMobileNumberData.asObservable();

  private _isSMSTokenGenerated = new BehaviorSubject(false);
  isSMSTokenGenerated$ = this._isSMSTokenGenerated.asObservable();

  // SMS Billing → Overview visibility flag (null = unknown)
  private _prepaidEnterprisePresent = new BehaviorSubject<number | null>(this.readPrepaidEnterprisePresentFromStorage());
  prepaidEnterprisePresent$ = this._prepaidEnterprisePresent.asObservable();

  constructor() {}

  /**
   * Check data obj is empty or not
   * @param obj
   * @param boolean
   */
  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  /** Store CHECK_ACCOUNT_STATUS API call
   * @param data
   * @return void
   */
  checkAccountStatus(data) {
    this._accountStatus.next(data);
  }

  /** Store GET_PLAN_TYPE API call
   * @param data
   * @return void
   */
  planType(data) {
    this._planType.next(data);
  }

  /** Store CHECK_PEPI_CLIENT API call
   * @param data
   * @return void
   */
  checkPepiClient(data) {
    this._isPepiClient.next(data);
  }

  /** Store CHECK_UNLIMITED_CODE_APPLIED API call
   * @param data
   * @return void
   */
  checkUnlimitedCodeApplied(data) {
    this._isUnlimitedCodeApplied.next(data);
  }

  /** Store WARMUPSLAB_DETAILS API call
   * @param data
   * @return void
   */
  warmupSlabDetails(data) {
    this._warmupSlabDetails.next(data);
  }

  /** Store GET_PROFILE_INFO API call
   * @param data
   * @return void
   */
  profileInfo(data) {
    this._profileInfo.next(data);
  }

  /** Store GET_CLIENT_ID API call
   * @param data
   * @return void
   */
  fetchClientId(data) {
    this._fetchClientId.next(data);
  }

  /**
   * Store ALL_DOMAIN_LIST API call
   * @param data
   * @return void
   */
  fetchDomainList(data) {
    this._fetchDomainList.next(data);
  }

  /**
   * Store GET_EMAIL_CREDITS API call
   * @param data
   * @return void
   */
  fetchCredits(data) {
    this._fetchCredits.next(data);
  }

  /**
   * Store PREFFERED_PLAN_DETAILS API call
   * @param data
   * @return void
   */
  fetchActivePreferredPlan(data) {
    this._fetchActivePreferredPlan.next(data);
  }

  /**
   * Store GET_NEW_SLAB_EMAIL_CREDITS API Call
   * @param data
   * @return void
   */
  fetchNewSlabCredits(data) {
    this._fetchNewSlabCredits.next(data);
  }

  /**
   * Store GET_AVAILABLE_EMAIL_CREDITS API Call
   * @param data
   * @return void
   */
  availableEmailCredits(data) {
    this._availableEmailCredits.next(data);
  }

  /**
   * Store GET_SUPPRESSION_EMAIL_ADDRESS API Call
   * @param data
   * @return void
   */
  suppresionCount(data) {
    this._suppresionCount.next(data);
  }

  /**
   * Store CHECK_SUBUSER API call
   * @param data
   * @void void
   */
  checkSubuser(data) {
    this._checkSubuser.next(data);
  }
  /**
   * Store CHECK_SUBUSER API call
   * @param data
   * @void void
   */
  newUI(data) {
    this._newUI.next(data);
  }
  newUIClass(data) {
    this._newUIClass.next(data);
  }
  activePath(data) {
    this._activePath.next(data);
  }

  setPageLevelAccess(val) {
    this._pageLevelAccess_Map.next(val);
  }

  /**
   * Store Insights datapoints filters params
   * @param data
   * @void void
   */
  setInsightsClickFilters(data) {
    this._insightsClickFilters.next(data);
  }

  /**
   * set boolean whether client is first time experience / no mailing history
   * @param data
   * @void void
   */
  setFirstTimeExperience(data) {
    console.log(" data service - setFirstTimeExperience ", data);
    this._isFirstTimeExperience.next(data);
  }

  /**
   * set boolean whether whatsapp client token has been generated
   * @param data
   * @void void
   */
  setWhatsappToken(data) {
    this._isWaTokenGenerated.next(data);
    sessionStorage.setItem('whatsappToken', String(data));
  }

  clearWhatsAppToken(){
    this._isWaTokenGenerated.next(false);
    sessionStorage.removeItem('whatsappToken');
  }
  /**
   * set value whether the hash is enabled or not for user
   * @param data
   * @void void
   */
  setHashEnabled(data) {
    this._isHashEnabled.next(data);
  }

  getWaMobileNumberData(data){
		this._isWaMobileNumberData.next(data);
	}

  /**
   * set boolean whether whatsapp client token has been generated
   * @param data
   * @void void
   */
  setSMSToken(data) {
    console.log("data service - setSMSToken ", data);
    this._isSMSTokenGenerated.next(data);
    localStorage.setItem('smsToken',data);
  }

  setPrepaidEnterprisePresent(flag: number | null) {
    this._prepaidEnterprisePresent.next(flag);
    if (flag === null || flag === undefined) {
      localStorage.removeItem(this.LS_SMS_PREPAID_ENTERPRISE_PRESENT);
      return;
    }
    localStorage.setItem(this.LS_SMS_PREPAID_ENTERPRISE_PRESENT, String(flag));
  }

  private readPrepaidEnterprisePresentFromStorage(): number | null {
    try {
      const raw = localStorage.getItem(this.LS_SMS_PREPAID_ENTERPRISE_PRESENT);
      if (raw === null || raw === undefined) return null;
      const asNumber = Number(raw);
      return Number.isNaN(asNumber) ? null : asNumber;
    } catch {
      return null;
    }
  }
}
